/**
 * Offer a blob as a download through a temporary object URL.
 *
 * @param {Blob} blob The blob to download.
 * @param {string} fileName The file name to save it as.
 */
export default (blob, fileName) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};
